import { render, staticRenderFns } from "./seleccionSimple.vue?vue&type=template&id=2d63c0de"
import script from "./seleccionSimple.vue?vue&type=script&lang=js"
export * from "./seleccionSimple.vue?vue&type=script&lang=js"
import style0 from "./seleccionSimple.vue?vue&type=style&index=0&id=2d63c0de&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports